import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { defaultLang } from './config-lang'
import enLocales from './langs/en'
import roLocales from './langs/ro'
import ruLocales from './langs/ru'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { business: roLocales },
      ru: { business: ruLocales },
      en: { business: enLocales }
    },
    ns: ['business'],
    defaultNS: 'business',
    fallbackLng: defaultLang.value,
    debug: false,
    keySeparator: '.',
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: '.'
    }
  })

export default i18n
